import {
  Media,
  Pricing,
  Profile,
  SocialReportDetail,
} from "core/types/social.types";
import { actionCreatorFactory } from "typescript-fsa";

const actionCreator = actionCreatorFactory("social");

export const resetSocial = actionCreator<void>("RESET");

export const isPostLoading = actionCreator<{
  isPostLoading: boolean;
}>("IS_POST_LOADING");

export const postList = actionCreator<{
  postList: Media[];
}>("POST_LIST");

export const postError = actionCreator<{
  error: string;
}>("POST_ERROR");

export const isPricingLoading = actionCreator<{
  isPricingLoading: boolean;
}>("IS_PRICING_LOADING");

export const pricingObject = actionCreator<{
  pricingObject: Pricing;
}>("PRICING_OBJECT");

export const reportSuccess = actionCreator<{
  success: string;
}>("REPORT_SUCCESS");

export const reportError = actionCreator<{
  error: string;
}>("REPORT_ERROR");

export const reportDetail = actionCreator<{
  detail: SocialReportDetail;
}>("REPORT_DETAIL");

export const isSocialReportLoading = actionCreator<{
  isSocialReportLoading: boolean;
}>("IS_SOCIAL_REPORT_LOADING");

export const profileList = actionCreator<{
  profileList: Profile[];
}>("PROFILE_LIST");

export const isProfilesLoading = actionCreator<{
  isProfilesLoading: boolean;
}>("IS_PROFILES_LOADING");

export const isReportReady = actionCreator<{
  isReportReady: boolean;
}>("IS_REPORT_READY");
